// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-default-dlg-style .mat-mdc-dialog-container {
    padding: 0px !important;
    overflow: unset !important;
    box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/service/stubs/video-stream-dialog/video-stream-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".reset-default-dlg-style .mat-mdc-dialog-container {\n    padding: 0px !important;\n    overflow: unset !important;\n    box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
